import { isDarkMode } from '@localstack/services';
import { Alert, styled } from '@mui/material';

export const WarningContainer = styled(Alert)(({ theme }) => ({
  backgroundColor: theme.palette.aws.background,
  color: isDarkMode(theme) ? theme.palette.aws.text : '#92400E',
  '& .MuiAlert-icon': {
    color: 'inherit',
  },
}));
